import { render, staticRenderFns } from "./homeComponent.vue?vue&type=template&id=4544d1d2&scoped=true"
import script from "./homeComponent.vue?vue&type=script&lang=js"
export * from "./homeComponent.vue?vue&type=script&lang=js"
import style0 from "./homeComponent.vue?vue&type=style&index=0&id=4544d1d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4544d1d2",
  null
  
)

export default component.exports